/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.12",
    versionName: "0.2.0-nightly.2025.9.12",
    versionChannel: "nightly",
    buildDate: "2025-09-12T00:07:16.834Z",
    commitHash: "79a8a2a3c741be326e9a0d59d1e2e9f257762782",
};
